<div class="row no-gutters">
  <div class="col-12 id-nodata" *ngIf="resourceKey">
    {{resourceKey | i18next  }}
  </div>
  <div class="col-12 id-nodata" *ngIf="!resourceKey">
    {{'profile.noData' | i18next  }}
  </div>
</div>